import { type ReactNode } from 'react';
import { iif } from '../function/iif';

interface Props {
  expression: boolean;
  then: ReactNode;
  else?: ReactNode;
}

export const Condition = ({ expression, then: thenNode, else: elseNode }: Props): ReactNode => {
  return iif(expression, thenNode, elseNode);
};

